import { render, staticRenderFns } from "./allocation-input.vue?vue&type=template&id=1080f52e"
import script from "./allocation-input.vue?vue&type=script&lang=js"
export * from "./allocation-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports